export class UrlUtils {
  static addLeadingSlash(url: string): string {
    return url.startsWith('/') ? url : `/${url}`;
  }
}
